import _ from 'lodash';

export const isNotPetOrMinor = (applicant: any) =>
  applicant?.applicantType?.name !== 'Minor' &&
  applicant?.applicantType?.name !== 'Pet';

export const getSelectedItemReceivedStatus = (selectedOption) => {
  const received = selectedOption?.received;
  if (_.isNil(selectedOption)) {
    return '---';
  }
  return received ? 'Received' : 'Pending';
};

export const shouldBypassMoveInRequirements = (selectedProperty: any) => {
  return (selectedProperty?.applicationProviderConfigs ?? []).some(
    (config) => config.isEnabled && config.bypassMoveInRequirements,
  );
};
